import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

import './InputWithUpload.scss';

export default class InputWithUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'files': '',
    };
    this.inputFile = createRef();
  }

  onButtonClick = () => {
    this.inputFile.current.click();
  };

    handleFileUpload = (e) => {
      const selectedFile = e.target.files[0];

      this.props.callback(selectedFile);

      this.setState({ 'files': selectedFile });
    };


    render() {
      const { placeholder, template, id, accept } = this.props;

      const { files } = this.state;

      return (
        <div className={`InputWithUpload${template ? ` template-${template}` : ''}`}>
          <div className={'group-input'}>
            <Input
              id={id}
              placeholder={placeholder}
              value={files && files.name}
              readOnly
            />
            <input
              style={{ 'display': 'none' }}
              ref={this.inputFile}
              onChange={this.handleFileUpload}
              type="file"
              accept={accept}
            />
            <span className="text" onClick={this.onButtonClick}>Upload</span>
          </div>
        </div>
      );
    }
}

InputWithUpload.propTypes = {
  'id': PropTypes.string,
  'placeholder': PropTypes.string,
  'template': PropTypes.string,
  'selectFile': PropTypes.object,
  'callback' : PropTypes.func,
};
